"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, memo } from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Tabs, Tab } from '@heroui/react';
import { Address } from 'viem';
import CreateListingForm from '@/components/marketplace/CreateListingForm';
import CreateAuctionForm from '@/components/marketplace/CreateAuctionForm';
import { useRouter } from 'next/navigation';
import toast from '@/util/toast';
export interface SellNFTDialogProps {
  chainId: number;
  contractAddress: Address;
  tokenId: string;
  collectionName?: string;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  defaultTab?: 'direct' | 'auction';
}
function SellNFTDialog(t0) {
  const $ = _c(21);
  const {
    chainId,
    contractAddress,
    tokenId,
    collectionName,
    isOpen,
    onClose,
    onSuccess,
    defaultTab: t1
  } = t0;
  const defaultTab = t1 === undefined ? "direct" : t1;
  const router = useRouter();
  const [activeTab, setActiveTab] = useState(defaultTab);
  let t2;
  if ($[0] !== onClose || $[1] !== onSuccess || $[2] !== router) {
    t2 = () => {
      toast.success("Listing created successfully!");
      onClose();
      router.refresh();
      onSuccess?.();
    };
    $[0] = onClose;
    $[1] = onSuccess;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleListingSuccess = t2;
  let t3;
  if ($[4] !== onClose || $[5] !== onSuccess || $[6] !== router) {
    t3 = () => {
      toast.success("Auction created successfully!");
      onClose();
      router.refresh();
      onSuccess?.();
    };
    $[4] = onClose;
    $[5] = onSuccess;
    $[6] = router;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleAuctionSuccess = t3;
  const modalTitle = collectionName ? `List ${collectionName} #${tokenId}` : `List NFT #${tokenId}`;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: "",
      header: "border-b border-neutral-800",
      body: "py-6",
      footer: ""
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeTab || $[10] !== chainId || $[11] !== contractAddress || $[12] !== handleAuctionSuccess || $[13] !== handleListingSuccess || $[14] !== modalTitle || $[15] !== tokenId) {
    t5 = <ModalContent>{onModalClose => <><ModalHeader className="flex flex-col gap-1">{modalTitle}</ModalHeader><ModalBody><Tabs selectedKey={activeTab} onSelectionChange={key => setActiveTab(key as string)} classNames={{
            base: "w-full",
            tabList: "w-full bg-neutral-800 rounded-lg p-1",
            tab: "h-10",
            tabContent: "text-neutral-400 group-data-[selected=true]:text-white",
            cursor: "bg-neutral-700"
          }}><Tab key="direct" title="Fixed Price"><div className="mt-4"><CreateListingForm chainId={chainId} assetContract={contractAddress} tokenId={tokenId} onSuccess={handleListingSuccess} /></div></Tab><Tab key="auction" title="Auction" disabled={true}><div className="mt-4"><CreateAuctionForm chainId={chainId} assetContract={contractAddress} tokenId={tokenId} onSuccess={handleAuctionSuccess} /></div></Tab></Tabs></ModalBody></>}</ModalContent>;
    $[9] = activeTab;
    $[10] = chainId;
    $[11] = contractAddress;
    $[12] = handleAuctionSuccess;
    $[13] = handleListingSuccess;
    $[14] = modalTitle;
    $[15] = tokenId;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== isOpen || $[18] !== onClose || $[19] !== t5) {
    t6 = <Modal isOpen={isOpen} onClose={onClose} size="3xl" backdrop="blur" scrollBehavior="inside" classNames={t4}>{t5}</Modal>;
    $[17] = isOpen;
    $[18] = onClose;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
export default memo(SellNFTDialog);